import ThemedImage from './ThemedImage';
export default ThemedImage;